type Handler<T = any> = (data: T) => any;

export class EventBus {
    private readonly handlers: Map<string, Handler[]> = new Map();

    public emit(event: string, data: any): void {
        const eventHandlers = this.handlers.get(event);
        if (eventHandlers) {
            eventHandlers.forEach((handler) => handler(data));
        }
    }

    public on<T>(event: string, handler: Handler<T>): void {
        if (!this.handlers.has(event)) {
            this.handlers.set(event, []);
        }
        this.handlers.get(event)!.push(handler);
    }

    public off<T>(event: string, handler: Handler<T>): void {
        const eventHandlers = this.handlers.get(event);
        if (eventHandlers) {
            const index = eventHandlers.indexOf(handler);
            if (index > -1) {
                eventHandlers.splice(index, 1);
            }
        }
    }
}

export const EVENT_PARAMETERS_VALIDATED = 'parametersValidated';
export const EVENT_LOCATION_VALIDATED = 'locationValidated';
